<template lang="pug">
  div.charts-new.analytic.chart
    Toolbar
    div.dashboard
      div.col.col--full-width
        component(:is="$route.params.chartId")
</template>
<script>
  import Toolbar from './components/toolbar.vue'
  import chartsMixin from './mixins/charts-mixin.js'

  import ChartDynamic from './components/chart-dynamic'
  import ChartGarbage from './components/chart-garbage'
  import ChartGarbageHandlingDynamic from './components/chart-garbage-handling-dynamic'
  import ChartGarbageProduction from './components/chart-garbage-production'
  import ChartGarbageVolume from './components/chart-garbage-volume'
  import ChartMsn from './components/chart-msn'
  import ChartMsnContainer from './components/chart-msn-container'
  import ChartGarbageOutput from './components/chart-garbage-output'

  export default {
    mixins: [chartsMixin],
    components: {
      msnContainer: ChartMsnContainer,
      msn: ChartMsn,
      garbageVolume: ChartGarbageVolume,
      garbageProduction: ChartGarbageProduction,
      garbageHandlingDynamic: ChartGarbageHandlingDynamic,
      garbage: ChartGarbage,
      dynamic: ChartDynamic,
      garbageOutput: ChartGarbageOutput,
      Toolbar
    }
  }
</script>

<style>
  .analytic.chart .col--full-width{
    width: 100%!important;
  }
</style>
